interface ErrorBoundaryProps {
  error: string
}

export function ErrorFallback({ error }: ErrorBoundaryProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="mx-auto max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-800">
        <div className="mb-4 flex items-center justify-center">
          <div className="rounded-full bg-red-100 p-3 dark:bg-red-900">
            <svg
              className="h-6 w-6 text-red-600 dark:text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
        </div>
        <h2 className="mb-2 text-center text-lg font-semibold text-gray-900 dark:text-white">
          Something went wrong
        </h2>
        <p className="mb-4 text-center text-sm text-gray-600 dark:text-gray-400">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        {error && (
          <details className="mb-4 rounded border border-gray-200 p-3 dark:border-gray-700">
            <summary className="cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-300">
              Error details
            </summary>
            <pre className="mt-2 text-xs whitespace-pre-wrap text-red-600 dark:text-red-400">
              {error.toString()}
            </pre>
          </details>
        )}
        <div className="flex gap-2">
          <button
            onClick={() => window.location.reload()}
            className="flex-1 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
